import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=c80c9db8&"
import script from "./BaseModal.vue?vue&type=script&lang=ts&"
export * from "./BaseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports